import { useState } from 'react';

const addLinkCallback = (link) => (prevLinks) => [...prevLinks, link];

const updateLinkCallback = (link) => (prevLinks) => {
  const index = prevLinks.findIndex(
    (existingLink) => existingLink.id === link.id
  );
  if (index === -1) {
    console.warn(`Link with id ${link.id} not found`);
    return prevLinks;
  }
  return prevLinks.toSpliced(index, 1, link);
};

const deleteLinkCallback = (id) => (prevLinks) => {
  return prevLinks.filter((link) => link.id !== id);
};

// Exposes useful operations to update a list of links for UI state.
// Prefer using the abstracted operations instead of using the setter directly, if possible.
export const useLinksState = (initialState) => {
  const [links, setLinks] = useState(initialState ?? []);

  const addLink = (link) => {
    setLinks(addLinkCallback(link));
  };

  const updateLink = (link) => {
    setLinks(updateLinkCallback(link));
  };

  const deleteLink = (id) => {
    setLinks(deleteLinkCallback(id));
  };

  return {
    links,
    setLinks,
    addLink,
    updateLink,
    deleteLink,
  };
};
